export default __webpack_public_path__ + "static/media/customer-not-selected.b413efd0.svg";